import React from 'react';

export interface AvatarProps {
  src?: string;
  alt?: string;
  initials?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

/**
 * Avatar component for displaying user profile images or initials
 *
 * If no image is provided, displays user initials in a colored circle
 */
export const Avatar: React.FC<AvatarProps> = ({ src, alt, initials, size = 'md', className }) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg',
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt || 'Avatar'}
        className={`${sizeClasses[size]} rounded-full object-cover ${className || ''}`}
      />
    );
  }

  return (
    <div
      className={`
        ${sizeClasses[size]}
        rounded-full
        bg-gradient-to-br from-indigo-500 to-purple-600
        text-white
        font-semibold
        flex items-center justify-center
        ${className || ''}
      `}
    >
      {initials}
    </div>
  );
};
